import React from 'react';
import { useStore } from "../../contexts/store";
import RoundSlider from "../RoundSlider";

const AnonymizeToggle = ({
  stateKey
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const shouldAnonymize = state[stateKey];

  const toggle = () => {
    dispatch({
      type: 'UPDATE',
      payload: {
        [stateKey]: !shouldAnonymize
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__invite-action_NEW"
  }, /*#__PURE__*/React.createElement(RoundSlider, {
    leftText: "Anon.",
    rightText: shouldAnonymize ? 'On' : 'Off',
    onClick: toggle,
    checked: shouldAnonymize,
    id: stateKey,
    onOffStyle: true
  }));
};

export default AnonymizeToggle;